import { render, staticRenderFns } from "./userordercategoryprocess.vue?vue&type=template&id=66e65984&"
import script from "./userordercategoryprocess.vue?vue&type=script&lang=js&"
export * from "./userordercategoryprocess.vue?vue&type=script&lang=js&"
import style0 from "./userordercategoryprocess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports